import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip';
import { getSellableProducts, getSellableProductById, setProductListEmpty, clearPosFilter } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { showError, hideLoading, showSnackbar } from 'actions/CommonActions';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import POSProductCategories from './POSProductCategories';
import 'styles/sass/pos/POSProduct.scss';

class POSProduct extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activePage: 1,
      categoryId: null,
      openDialogAddProduct: false,
      isLoading: false,
      isAddingProduct: false,
      openPriceMenu: false,
      openPotencyMenu: false,
      openNameMenu: false,
      POSSpeciesCheckbox: [],
      POSTypeCheckbox: 3,
      POSWeightCheckbox: [],
      POSBrandCheckbox: [],
      potencyLabel: this.props.t('pos.product.sortByChem'),
      priceLabel: this.props.t('pos.product.sortByPrice'),
      hideMenu: false,
      weightTextValue: "",
      weightSelectedText: "",
      POSOnSale: false,
      POSOnSaleMemberOnly: false,
      shownBrandCount: 5
    };
    this.prevValue = ""
  }

  componentDidMount() {
    this.props.formInput('', this.props.name + 'ProductSearch');
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.posOrderSaveSuccess && this.props.posOrderSaveSuccess !== newProps.posOrderSaveSuccess) {
      this.setState({ isAddingProduct: false });
    }

    if (this.props.productFilter !== newProps.productFilter && newProps.productFilter) {
      const filters = {
        productId: newProps.productFilter.productId,
        branchId: this.props.branchId
      };
      this.props.getProductbyId(filters);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.POSBasicCategory !== this.props.POSBasicCategory ||
      !this.arraysEqual(prevProps.POSSubCategory, this.props.POSSubCategory)
      || !this.arraysEqual(prevProps.POSWeightsList, this.props.POSWeightsList) ||
      !this.arraysEqual(prevProps.POSBrandsList, this.props.POSBrandsList)
    ) {
      this.setLoadingState(true);
    }
    if (prevProps.POSSortFilter !== this.props.POSSortFilter) {
      this.setLoadingState(false);
    }
    if (prevProps.productsLength !== this.props.productsLength) {
      this.setLoadingState(false);
    }
    if (!this.arraysEqual(prevState.POSWeightCheckbox, this.state.POSWeightCheckbox)) {
      this.getFormattedWeights();
    }
  }

  setLoadingState = (isLoading) => {
    this.setState({ isLoading });
  }

  arraysEqual = (prevProps, newProps) => {
    if (prevProps === newProps) return true;
    if (prevProps == null || newProps == null) return false;
    if (prevProps.length !== newProps.length) return false;

    for (let i = 0; i < prevProps.length; ++i) {
      if (prevProps[i] !== newProps[i]) return false;
    }
    return true;
  }

  pageChange = (page) => {
    this.setState({ activePage: page }, () => {
      this.search();
    });
  }

  filter = (categoryId) => {
    this.props.formInput(categoryId, "POSCategory");
    this.props.setProductListEmpty();
    this.setState(
      {
        categoryId: categoryId ? categoryId : null,
        activePage: 1
      }, () => {
        this.search();
      });
  }

  clear = () => {
    this.props.clearFormInput(`POSProductsProductSearch`);
    this.props.formInput("3", "POSTypeCheckbox");
    this.props.formInput([], "POSWeightCheckbox");
    this.props.formInput([], "POSBrandCheckbox");
    this.props.formInput([], "POSSpeciesCheckbox");
    this.props.formInput(null, "POSCategory");
    this.props.formInput(0, `SortFilter`);
    this.props.formInput([], "POSSpeciesCheckbox");
    this.props.formInput(null, "POSCategory");
    this.props.formInput(false, `POSOnSale`);
    this.props.formInput(false, `POSOnSaleMemberOnly`);
    // Clear current Product List and search again
    this.props.setProductListEmpty();

    this.setState({
      POSTypeCheckbox: LOOKUP.POSfilterType[0].value, // dont use t('') here!
      POSSpeciesCheckbox: [],
      POSWeightCheckbox: [],
      POSBrandCheckbox: [],
      categoryId: null,
      potencyLabel: this.props.t('pos.product.sortByChem'),
      priceLabel: this.props.t('pos.product.sortByPrice'),
      weightSelectedText: "",
      POSOnSale: false,
      POSOnSaleMemberOnly: false,
      activePage: 1
    }, () => {
      this.search();
    });
  }

  search = (searchText) => {
    const filters = {
      page: this.state.activePage,
      itemsPerPage: this.props.posShowProductCount,
      searchText: searchText != undefined ? searchText : (this.props.searchText ? this.props.searchText : null),
      categoryId: this.state.categoryId,
      baseCategoryId: this.props.POSBasicCategory,
      subCategoryId: this.props.POSSubCategory ? this.props.POSSubCategory : [],
      Weight: this.props.POSWeightsList ? this.props.POSWeightsList : [],
      Brand: this.props.POSBrandsList ? this.props.POSBrandsList : [],
      SortId: this.props.POSSortFilter ? this.props.POSSortFilter : 0,
      branchId: this.props.branchId,
      THC_MIN: this.props.THC_MIN ? this.props.THC_MIN : 0,
      THC_MAX: this.props.THC_MAX ? this.props.THC_MAX : 100,
      CBD_MIN: this.props.CBD_MIN ? this.props.CBD_MIN : 0,
      CBD_MAX: this.props.CBD_MAX ? this.props.CBD_MAX : 100,
      onSale: this.state.POSOnSale,
      onSaleMemberOnly: this.state.POSOnSaleMemberOnly
    };

    // Clear current Product List and search again
    this.props.getProducts(filters);
  }

  handleSearch = () => {
    if (this.props.searchText === "") return
    this.setState(
      {
        activePage: 1
      }, () => {
        this.search();
      });
  }

  closeAddProductDialog = () => {
    this.setState({ openDialogAddProduct: false });
    this.props.updateDialogProduct(null)
  }

  onProductSearchKeyPress = (e) => {
    // console.log(e.target.value)
    if (e.key === 'Enter') {
      e.target.blur();
      this.setState(
        {
          activePage: 1
        }, () => {
          this.search(e.target.value)
        });
      this.props.setProductListEmpty();
    }
  }

  handleClick = (menuName) => {
    const { openPriceMenu, openPotencyMenu, openNameMenu } = this.state;
    let shouldCloseMenu = false;

    if (menuName === 'openPriceMenu' && openPriceMenu) {
      shouldCloseMenu = true;
    } else if (menuName === 'openPotencyMenu' && openPotencyMenu) {
      shouldCloseMenu = true;
    } else if (menuName === 'openNameMenu' && openNameMenu) {
      shouldCloseMenu = true;
    }

    if (menuName === 'openPotencyMenu' && (openPriceMenu || openNameMenu)) {
      this.setState({ openPriceMenu: false, openNameMenu: false });
    } else if (menuName === 'openPriceMenu' && (openPotencyMenu || openNameMenu)) {
      this.setState({ openPotencyMenu: false, openNameMenu: false });
    } else if (menuName === 'openNameMenu' && (openPriceMenu || openPotencyMenu)) {
      this.setState({ openPriceMenu: false, openPotencyMenu: false });
    }

    if (shouldCloseMenu) {
      this.setState({ [menuName]: false });
      document.removeEventListener('click', this.handleOutsideClick);
    } else {
      this.setState({ [menuName]: true });
      document.addEventListener('click', this.handleOutsideClick);
    }
  };

  handleClose = (menuName) => {
    this.setState({ [menuName]: false });
    document.removeEventListener('click', this.handleOutsideClick);
  };

  handleOutsideClick = (event) => {
    const target = event.target;
    if (!target.closest('.chip-container')) {
      this.handleClose('openPriceMenu');
      this.handleClose('openPotencyMenu');
    }
  };

  handleCheck = (e, isChecked, value, name, menuName = "") => {
    if (menuName === 'openPriceMenu') {
      this.setState({
        openPotencyMenu: false,
        potencyLabel: this.props.t('pos.product.sortByChem'),
      });
    }
    if (menuName === 'openPotencyMenu') {
      this.setState({
        openPriceMenu: false,
        priceLabel: this.props.t('pos.product.sortByPrice'),
      });
    }
    if (name === 'POSSpeciesCheckbox' || name === "POSWeightCheckbox" || name === "POSBrandCheckbox") {
      if (isChecked) {
        this.setState(prevState => ({
          [name]: [...prevState[name], value]
        }), () => this.props.formInput(this.state[name], name));
      } else {
        this.setState(prevState => ({
          [name]: prevState[name].filter(checkbox => checkbox !== value)
        }), () => this.props.formInput(this.state[name], name));
      }
    } else if (name === 'POSTypeCheckbox') {
      if (!isChecked && this.state.POSTypeCheckbox === value) {
        return;
      }
      this.setState({
        POSTypeCheckbox: value
      }, () => this.props.formInput(this.state[name], name));
    } else if (name === 'SortFilter') {
      this.setState({
        SortFilter: value,
        isLoading: true
      }, () => this.props.formInput(this.state[name], name));
    }
  }

  handleOnSale = (e, isChecked) => {
    this.props.formInput(isChecked, 'POSOnSale');
    this.props.formInput(false, 'POSOnSaleMemberOnly');

    this.setState(
      {
        POSOnSale: isChecked,
        POSOnSaleMemberOnly: false,
        activePage: 1
      }, () => {
        this.search();
      });
    this.props.setProductListEmpty();
  }

  handleOnSaleMemberOnly = (e, isChecked) => {
    this.props.formInput(isChecked ? true : this.props.POSOnSale, 'POSOnSale');
    this.props.formInput(isChecked, 'POSOnSaleMemberOnly');
    this.setState(
      {
        POSOnSale: isChecked ? true : this.props.POSOnSale,
        POSOnSaleMemberOnly: isChecked,
        activePage: 1
      }, () => {
        this.search();
      });
    this.props.setProductListEmpty();
  }

  handleSortLabelShow = (newLabel, menuName) => {
    const objectLookLabel = {
      "openPotencyMenu": "potencyLabel",
      "openPriceMenu": "priceLabel"
    };
    const stateToUpdate = objectLookLabel[menuName];
    if (stateToUpdate) {
      this.setState({ [stateToUpdate]: newLabel })
    }
  }

  weightTextHandleChange = (e) => {
    const { value } = e.target;
    const min = 0;
    const max = 300;

    if (this.weightTimeout) {
      clearTimeout(this.weightTimeout);
    }

    if (value < min || value > max) {
      this.props.showSnackbar(this.props.t('pos.product.enterWeight'));
      this.setState({ weightTextValue: "" });
      return;
    } else if (value >= min && value <= max) {
      this.setState({ weightTextValue: value });

      this.weightTimeout = setTimeout(() => {
        const trimmedValue = value.trim();
        let updatedArray = [...this.state.POSWeightCheckbox];

        if (trimmedValue) {
          if (!updatedArray.includes(trimmedValue)) {
            updatedArray.push(trimmedValue);
          }
        } else {
          updatedArray = updatedArray.filter(item => item !== this.prevValue);
        }

        this.prevValue = trimmedValue;

        this.setState({
          POSWeightCheckbox: updatedArray,
          weightTextValue: ""
        }, () => this.props.formInput(this.state.POSWeightCheckbox, "POSWeightCheckbox"));
      }, 2000);
    }
  }

  getFormattedWeights = () => {
    const formattedWeights = this.state.POSWeightCheckbox.map(weight => weight + "g");
    const formattedString = formattedWeights.join(", ");
    this.setState({ weightSelectedText: formattedString });
  }

  handleViewMoreBrands = () => {
    this.setState(prevState => ({ shownBrandCount: prevState.shownBrandCount + 5 }));
  }

  handleViewLessBrands = () => {
    this.setState(prevState => ({ shownBrandCount: prevState.shownBrandCount - 5 }));
  }

  render() {
    const { t } = this.props; 
    const p = this.props;
    const s = this.state;
    const { openPriceMenu, openPotencyMenu, potencyLabel, priceLabel, shownBrandCount } = s;
    const { hideSideBar, hideMenu, brandList, hideSearchBar, ProductsWeightList, posOrder: order } = p;
    const memberSelected = order && order.patientId && order.patientId !== 0;
    const items = p.productCategories && p.productCategories.filter(c => c.categoryStatus === 1).map((item) => {
      return {
        label: item.name,
        value: item.id,
        isCannabis: item.isCannabis
      };
    });
    const filteredSpecies = p.isVape ? [7, 8, 9, 10, 11] : [1, 2, 3, 5];
    const weightListCheckBoxOptions = ProductsWeightList || LOOKUP.POSWeightList;  // no need to translate here

    return (
      <div className="sidebar_categoriesContainer">
        {/* POS SideBar Start */}
        {!hideMenu ?
          (<div className="sidebar-container">
            <section style={{ position: 'relative' }}>
              {p.isVape ? null : (
                <div className="chip-container">
                  <Chip
                    className="lightPurpleBackground"
                    label={
                      <span>
                        <span>{potencyLabel}</span>
                        {openPotencyMenu ? (
                          <RemoveIcon sx={{ color: "green", width: 20, height: 20 }} />
                        ) : (
                          <AddIcon sx={{ color: "green", width: 20, height: 20 }} />
                        )}
                      </span>
                    }
                    onClick={() => this.handleClick('openPotencyMenu')}
                  />
                  {openPotencyMenu && (
                    <div className="long-chip-container">
                      <Chip
                        className="lightPurpleBackground"
                        label={t('pos.product.THCHighToLow')}
                        onClick={() => {
                          this.handleClose('openPotencyMenu');
                          this.handleCheck(null, true, 5, "SortFilter", "openPotencyMenu");
                          this.handleSortLabelShow(t('pos.product.THCHighToLow'), 'openPotencyMenu');
                        }}
                        name="SortFilter"
                        sx={{
                          fontWeight: "bold",
                          fontSize: "12px",
                          marginBottom: "5px",
                        }}
                      />
                      <Chip
                        className="lightPurpleBackground"
                        label={t('pos.product.THCLowToHigh')}
                        onClick={() => {
                          this.handleClose('openPotencyMenu');
                          this.handleCheck(null, true, 6, "SortFilter", "openPotencyMenu");
                          this.handleSortLabelShow(t('pos.product.THCLowToHigh'), 'openPotencyMenu');
                        }}
                        name="SortFilter"
                        sx={{
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      />
                      <Chip
                        className="lightPurpleBackground"
                        label={t('pos.product.CBDHighToLow')}
                        onClick={() => {
                          this.handleClose('openPotencyMenu');
                          this.handleCheck(null, true, 3, "SortFilter", "openPotencyMenu");
                          this.handleSortLabelShow(t('pos.product.CBDHighToLow'), 'openPotencyMenu');
                        }}
                        name="SortFilter"
                        sx={{
                          fontWeight: "bold",
                          fontSize: "12px",
                          marginBottom: "5px",
                          marginTop: "5px",
                        }}
                      />
                      <Chip
                        className="lightPurpleBackground"
                        label={t('pos.product.CBDLowToHigh')}
                        onClick={() => {
                          this.handleClose('openPotencyMenu');
                          this.handleCheck(null, true, 4, "SortFilter", "openPotencyMenu");
                          this.handleSortLabelShow(t('pos.product.CBDLowToHigh'), 'openPotencyMenu');
                        }}
                        name="SortFilter"
                        sx={{
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      />
                    </div>
                  )}
                </div>
              )}
              <div className="sidebar-container-show">
                <IconButton className="sidebar-container-show-button" onClick={hideSideBar}>
                  <RemoveIcon sx={{ color: "green" }} />
                </IconButton>
              </div>
            </section>
            <section style={{ position: 'relative' }}>
              <div className="chip-container">
                <Chip
                  className="lightPurpleBackground"
                  label={
                    <Box sx={{ fontWeight: "bold", fontSize: "12px", position: 'relative' }}>
                      {priceLabel}
                      {openPriceMenu ? (
                        <RemoveIcon sx={{ color: "green", width: 20, height: 20 }} />
                      ) : (
                        <AddIcon sx={{ color: "green", width: 20, height: 20 }} />
                      )}
                    </Box>
                  }
                  onClick={() => this.handleClick('openPriceMenu')}
                  sx={{
                    padding: "4px",
                  }}
                />
                {openPriceMenu && (
                  <div className="short-chip-container">
                    <Chip
                      className="lightPurpleBackground"
                      label={t('pos.product.priceHighToLow')}
                      onClick={() => {
                        this.handleClose('openPriceMenu');
                        this.handleCheck(null, true, 1, "SortFilter", "openPriceMenu");
                        this.handleSortLabelShow(t('pos.product.priceHighToLow'), 'openPriceMenu');
                      }}
                      name="SortFilter"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "12px",
                        marginBottom: "5px",
                        padding: "4px"
                      }}
                    />
                    <Chip
                      className="lightPurpleBackground"
                      label={t('pos.product.priceLowToHigh')}
                      onClick={() => {
                        this.handleClose('openPriceMenu');
                        this.handleCheck(null, true, 2, "SortFilter", "openPriceMenu");
                        this.handleSortLabelShow(t('pos.product.priceLowToHigh'), 'openPriceMenu');
                      }}
                      name="SortFilter"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "12px",
                        marginBottom: "5px",
                      }}
                    />
                  </div>
                )}
              </div>
            </section>
            <section>
              <h6>{t('pos.product.types')}</h6>
              {[
                { cannabisLabel: t("pos.productCategories.all"), vapeLabel: t("pos.productCategories.all"), value: 3 },
                { cannabisLabel: t("pos.productCategories.cannabis"), vapeLabel: t("pos.productCategories.vape"), value: 1 },
                { cannabisLabel: t("pos.productCategories.nonCannabis"), vapeLabel: t("pos.productCategories.accessories"), value: 2 }
              ].map((type, i) =>
                // <Checkbox
                //   key={i}
                //   name="POSTypeCheckbox"
                //   label={p.isVape ? type.vapeLabel : type.cannabisLabel}
                //   checked={s.POSTypeCheckbox === type.value}
                //   labelStyle={{ marginLeft: '-15px', color: "#5F4BB3" }}
                //   onCheck={(e, isChecked) => this.handleCheck(e, isChecked, type.value, "POSTypeCheckbox")}
                //   style={{}}
                // />
                <FormControlLabel
                  key={i}
                  control={
                    <Checkbox
                      name="POSTypeCheckbox"
                      checked={s.POSTypeCheckbox === type.value}
                      onChange={(e, isChecked) => this.handleCheck(e, isChecked, type.value, "POSTypeCheckbox")}
                    />
                  }
                  label={type.isVape ? type.vapeLabel : type.cannabisLabel}
                  sx={{
                    color: "#5F4BB3"
                  }}
                />
              )}
            </section>
            <section>
              <h6>{p.isVape ? t('pos.product.variants') : t('pos.product.species')}</h6>
              <div className={p.isVape ? "multicheckbox-container-vape" : "multicheckbox-container"}>
                {LOOKUP.POSfilterSpecies.map((type, i) =>  // no need to translate
                  filteredSpecies.includes(type.value) && (
                    <FormControlLabel
                      key={i}
                      control={
                        <Checkbox
                          name="POSSpeciesCheckbox"
                          checked={s.POSSpeciesCheckbox.includes(type.value)}
                          onChange={(e, isChecked) => this.handleCheck(e, isChecked, type.value, "POSSpeciesCheckbox")}
                        />
                      }
                      label={type.label}
                      sx={{
                        color: "#5F4BB3"
                      }}
                    />
                  )
                )}
              </div>
            </section>
            <section>
              <h6>{p.isVape ? t('pos.product.brands') : t('pos.product.weights')}</h6>
              {
                p.isVape
                  ? (
                    brandList && brandList.length > 0
                      ? (
                        <div className="multicheckbox-container-brands">
                          {brandList.slice(0, shownBrandCount).map((brand, i) => (
                            <FormControlLabel
                              key={i}
                              control={
                                <Checkbox
                                  name="POSBrandCheckbox"
                                  checked={s.POSBrandCheckbox.includes(brand)}
                                  onChange={(e, isChecked) => this.handleCheck(e, isChecked, brand, "POSBrandCheckbox")}
                                />
                              }
                              label={t('pos.product.brand')}
                              sx={{
                                color: "#5F4BB3"
                              }}
                            />
                          ))}
                          {shownBrandCount < brandList.length ? (
                            <a
                              id="viewMoreLink"
                              onClick={this.handleViewMoreBrands}>
                              {t('pos.product.viewMore')}
                            </a>
                          ) : (
                            <a
                              id="viewLessLink"
                              onClick={this.handleViewLessBrands}>
                              {t('pos.product.viewLess')}
                            </a>
                          )}
                        </div>
                      )
                      : null
                  )
                  : (
                    <React.Fragment>
                      <div className="multicheckbox-container POSWeightCheckboxList">
                        {weightListCheckBoxOptions.map((weight, i) =>
                          <FormControlLabel
                            key={i}
                            control={
                              <Checkbox
                                name="POSWeightCheckbox"
                                checked={s.POSWeightCheckbox.includes(weight.value)}
                                onChange={(e, isChecked) => this.handleCheck(e, isChecked, weight.value, "POSWeightCheckbox")}
                              />
                            }
                            label={weight.label}
                            sx={{
                              ml: '0px', // margin-left
                              color: "#5F4BB3"
                            }}
                          />
                        )}
                      </div>

                      <div style={{ display: 'flex', alignItems: 'center', width: '175px' }}>
                        <IconButton style={{ display: 'flex', padding: '0px', height: 'auto', justifyContent: 'flex-start', width: "25px", cursor: "auto" }}>
                          <img src="https://i.imgur.com/lMI49UN.png" alt="icon" style={{ maxWidth: '25px', height: 'auto' }} />
                        </IconButton>
                        <TextField variant="standard" style={{ flex: 1, marginTop: 4, marginBottom: 12, marginLeft: 8 }} onChange={this.weightTextHandleChange} value={this.state.weightTextValue} type="number" />
                      </div>
                    </React.Fragment>
                  )
              }
            </section>
            <section>
              <FormControlLabel
                control={
                  <Checkbox
                    name="POSOnSale"
                    className="mb-6px fullWidth"
                    checked={s.POSOnSale}
                    onChange={(e, isChecked) => this.handleOnSale(e, isChecked)}
                  />
                }
                label={t('pos.product.onSale')}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="POSOnSaleMemberOnly"
                    className="mb-6px fullWidth"
                    checked={s.POSOnSaleMemberOnly}
                    onChange={(e, isChecked) => this.handleOnSaleMemberOnly(e, isChecked)}
                  />
                }
                label={t('pos.product.memberSale')}
              />
            </section>
            <section className="reset-button-container">
              <Button
                className="fullWidth"
                type="RaisedButton"
                labelcolor="#ffffff"
                onTouchTap={this.clear}
                label={t('pos.product.resetFilters')}
              />
            </section>
          </div>) :
          <div className="sidebar-container-hide">
            <IconButton className="sidebar-container-hide-button" onClick={hideSideBar}>
              <AddIcon color="green" />
            </IconButton>
          </div>}
        {/* POS SideBar End */}
        <div className={!hideMenu ? "searchBar_Catergories_container" : "hide-searchBar_Catergories_container"}>
          <div className="search_bar_container">
            {!hideSearchBar ? <div className="searchContainer">
              <div className="col-lg-8 searchField">
                <TextInput
                  id="product_search_focus"
                  name={`${p.name}ProductSearch`}
                  fullWidth={false}
                  placeholder={p.isVape ? t('pos.product.searchByNameOrSku') : t('pos.product.searchByNameOrSkuOrTerpene')}
                  onKeyPress={this.onProductSearchKeyPress}
                />

                <IconButton
                  className="searchIcon"
                  id="searchIcon"
                  name={`${p.name}Search`}
                  onClick={this.handleSearch}
                >
                  <SearchIcon />
                </IconButton>
              </div>
              {
                s.isLoading ?
                  <div className="loading">
                    <CircularProgress size={30} thickness={3} />
                  </div>
                  : null
              }
              {!s.isLoading ? <div className="col-lg-4 searchResultNum text-right">
                <p className="POS-search-result-count">{p.productsLength} {t('pos.product.results')}</p>
              </div> : null
              }
            </div> : null}
          </div>
          <div>
            <POSProductCategories onSelect={(value) => this.filter(value)} selectedValue={s.categoryId} items={items} selectedTab={null} />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    productCategories: state.entity.productCategories || [],
    products: state.entity.sellableProducts,
    productsLength: state.entity.sellableProductsLength,
    searchText: state.form[`${ownProps.name}ProductSearch`],
    posOrder: state.entity.posOrder,
    posOrderSaveSuccess: state.form.posOrderSaveSuccess,
    branchId: state.common.branchId,
    productFilter: state.entity.productFilter,
    POSBasicCategory: state.form[`POSTypeCheckbox`],
    POSSubCategory: state.form[`POSSpeciesCheckbox`],
    POSWeightsList: state.form[`POSWeightCheckbox`],
    POSBrandsList: state.form[`POSBrandCheckbox`],
    POSSortFilter: state.form[`SortFilter`],
    THC_MIN: state.form[`THCSliderMIN`],
    THC_MAX: state.form[`THCSliderMAX`],
    CBD_MIN: state.form[`CBDSliderMIN`],
    CBD_MAX: state.form[`CBDSliderMAX`],
    POSOnSale: state.form[`POSOnSale`],
    POSOnSaleMemberOnly: state.form[`POSOnSaleMemberOnly`],
    showImageInPOSPage: state.common.applicationSettings.showImageInPOSPage,
    posShowProductCount: state.common.applicationSettings.posShowProductCount,
    sellableProductsAll: state.entity.sellableProductsAll,
    weightList: state.entity.weightList,
    brandList: state.entity.brandList,
    loading: (state.common.ajaxCallsInProgress > 0) || state.common.loading,
    hideSearchBar: state.common.applicationSettings.hideSearchBar,
    isVape: state.common.applicationSettings.isVape,
    ProductsWeightList: state.entity.sellableProductsWeightList ? state.entity.sellableProductsWeightList.length > 0 ? state.entity.sellableProductsWeightList : null : null
  };
}

function mapDispatchToProps(dispatch) {
  return {
    formInput: (value, name) => dispatch(formInput(value, name)),
    clearFormInput: (name) => dispatch(clearFormInput(name)),
    getProducts: (filters) => dispatch(getSellableProducts(filters)),
    showError: (message) => dispatch(showError(message)),
    getProductbyId: (filter) => dispatch(getSellableProductById(filter)),
    setProductListEmpty: () => dispatch(setProductListEmpty()),
    clearPosFilter: () => dispatch(clearPosFilter()),
    hideLoading: () => dispatch(hideLoading()),
    showSnackbar: (message) => dispatch(showSnackbar(message))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSProduct))